"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const MainContent = _ref => {
  let {
    menuItems,
    sectionsRefs
  } = _ref;
  return menuItems.map(item => /*#__PURE__*/_react.default.createElement("section", {
    key: `sideSection_${item.props['data-id']}}`,
    ref: sectionsRefs[item.props['data-id']],
    "data-id": item.props['data-id'],
    "data-testid": item.props['data-id']
  }, item.props?.children));
};
var _default = exports.default = MainContent;
MainContent.propTypes = {
  menuItems: _propTypes.default.arrayOf(_propTypes.default.node).isRequired,
  sectionsRefs: _propTypes.default.any.isRequired
};